import { css, Interpolation, Theme } from '@emotion/react'
import { Dispatch, memo, SetStateAction, useCallback } from 'react'
import ChevronDown from '../Icons/ChevronDown'
import ChevronUp from '../Icons/ChevronUp'
import IconButton from './IconButton'

const expandCollapseButtonStyles = css({
    top: 4,
    padding: 4,
})

interface ExpandCollapseButtonProps {
    chevronSize?: number | string
    isExpanded: boolean
    setIsExpanded: Dispatch<SetStateAction<boolean>>
    styleOverrides?: Interpolation<Theme>
}

const ExpandCollapseButton = memo((props: ExpandCollapseButtonProps) => {
    const {
        chevronSize = 0.8,
        isExpanded,
        setIsExpanded,
        styleOverrides,
    } = props

    const onClick = useCallback(() => setIsExpanded(!isExpanded), [isExpanded])
    return (
        <IconButton
            css={[expandCollapseButtonStyles, styleOverrides]}
            onClick={onClick}
        >
            {isExpanded ? (
                <ChevronUp size={chevronSize} />
            ) : (
                <ChevronDown size={chevronSize} />
            )}
        </IconButton>
    )
})

export default ExpandCollapseButton
